export { default as EventEmitter } from 'eventemitter3';

"use strict";
const DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const VERSION = "8.14.1";

export { DATA_URI, VERSION };
//# sourceMappingURL=const.mjs.map
